<nz-tabset [nzLinkRouter]="routing">
  <ng-container *ngIf="routing">
    <ng-container *ngFor="let tab of tabs">
      <ng-container *ngIf="routing">
        <nz-tab
          [nzDisabled]="tab.disabled"
          *appAccessCtrl="tab.tabPermission.id"
        >
          <a
            [ngClass]="'app-tab-btn'"
            nz-button
            nzType="link"
            [disabled]="tab.disabled"
            *nzTabLink
            nz-tab-link
            [routerLink]="tab.routerLink"
            [queryParamsHandling]="tab.queryParamsHandling"
            ><i
              *ngIf="tab.faClassPrefix"
              [style]="tab.tabPermission.title ? 'margin-right: 5px;' : ''"
              class="fal"
              [ngClass]="tab.faClassPrefix"
            ></i>
            <i
              [ngClass]="tab.tabPermission.title ? '' : 'm-0'"
              *ngIf="tab.nzTypePrefix"
              nz-icon
              [nzType]="tab.nzTypePrefix"
            ></i>
            {{ tab.tabPermission.title | translate }}
            <i
              *ngIf="tab.faClassSuffix"
              [style]="tab.tabPermission.title ? 'margin-left: 5px;' : ''"
              class="fal"
              [ngClass]="tab.faClassSuffix"
            ></i>
            <i
              [ngClass]="tab.tabPermission.title ? '' : 'm-0'"
              *ngIf="tab.nzTypeSuffix"
              nz-icon
              [nzType]="tab.nzTypeSuffix"
            ></i
          ></a>
        </nz-tab>
      </ng-container>

      <ng-container *ngIf="!routing">
        <nz-tab [nzTitle]="titleTemplate" *appAccessCtrl="tab.tabPermission.id">
          <ng-content select="[tabItem]"></ng-content>
        </nz-tab>
      </ng-container>
    </ng-container>
  </ng-container>
</nz-tabset>

<ng-template #titleTemplate let-tab>
  <i
    *ngIf="tab.faClassPrefix"
    [style]="tab.tabPermission.title ? 'margin-right: 5px;' : ''"
    class="fal"
    [ngClass]="tab.faClassPrefix"
  ></i>
  <i
    [ngClass]="tab.tabPermission.title ? '' : 'm-0'"
    *ngIf="tab.nzTypePrefix"
    nz-icon
    [nzType]="tab.nzTypePrefix"
  ></i>
  {{ tab.tabPermission.title | translate }}
  <i
    *ngIf="tab.faClassSuffix"
    [style]="tab.tabPermission.title ? 'margin-left: 5px;' : ''"
    class="fal"
    [ngClass]="tab.faClassSuffix"
  ></i>
  <i
    [ngClass]="tab.tabPermission.title ? '' : 'm-0'"
    *ngIf="tab.nzTypeSuffix"
    nz-icon
    [nzType]="tab.nzTypeSuffix"
  ></i>
</ng-template>
